import { Pipe, PipeTransform } from '@angular/core';
import {ThemeService} from '@services/theme-service';

@Pipe({
  name: 'iconPath',
  standalone: true,
  pure: false
})
export class IconPathPipe implements PipeTransform {
  constructor(private themeService: ThemeService) {
  }
  transform(iconName: unknown, ...args: unknown[]): unknown {
    if (typeof iconName === 'string') {
      const theme = this.themeService.isDarkMode ? 'dark' : 'light';
      return `assets/icons/main/${theme}/ico-${iconName}.svg`;
    }
    return null;
  }
}
